module.exports = __webpack_public_path__ + "static/img/14000280.b2a7d617.png";